module.exports = __webpack_public_path__ + "img/girl_run.9dce8fd6.png";